import useTypedContext from "hooks/useTypedContext";

import ScanSettingsFormWrapper from "../components/FormWrapper";
import ScanSettingsPageLayout from "../components/PageLayout";
import { ScanSettingsContextData } from "../Context";
import ScanSettingsResourceScopeEdit from "./Edit";
import ScanSettingsResourceScopeView from "./View";

const ScanSettingsResourceScope = () => {
  const { canUpdateScan } = useTypedContext(ScanSettingsContextData);

  return (
    <ScanSettingsPageLayout
      title="Scope of resources"
      description="Choose which resource types this scan discovers."
    >
      <ScanSettingsFormWrapper>
        {canUpdateScan.result ? (
          <ScanSettingsResourceScopeEdit />
        ) : (
          <ScanSettingsResourceScopeView />
        )}
      </ScanSettingsFormWrapper>
    </ScanSettingsPageLayout>
  );
};

export default ScanSettingsResourceScope;
